
import { LevelAppsCategoriesTable } from "./LevelAppsCategoriesTable";

interface LevelAppsCategoriesContentProps {
  levelId: string;
  appFilter?: any;
}

export const LevelAppsCategoriesContent = ({ levelId, appFilter }: LevelAppsCategoriesContentProps) => {
  return <LevelAppsCategoriesTable levelId={levelId} appFilter={appFilter} />;
};
